var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagSintMaarten(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1354_16465)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.609 17.4021C14.609 17.4021 4.6959 4.6948 4.68652 4.69705C7.5819 1.80162 11.582 0.0107422 16.0003 0.0107422C24.8368 0.0107422 32.0003 7.17424 32.0003 16.0107L14.609 17.4021Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.609 16.0107C14.609 16.0107 4.6959 27.3267 4.68652 27.3244C7.5819 30.2199 11.582 32.0107 16.0003 32.0107C24.8368 32.0107 32.0003 24.8472 32.0003 16.0107H14.609Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.68625 4.69702C-1.56212 10.9454 -1.56212 21.0761 4.68625 27.3245C7.26831 24.7425 9.75163 22.2591 16 16.0108L4.68625 4.69702Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.75382 16.0107C1.74507 16.1256 1.73914 16.2414 1.73914 16.3585C1.73914 18.8557 3.76364 20.8802 6.26089 20.8802C8.75814 20.8802 10.7826 18.8557 10.7826 16.3585C10.7826 16.2414 10.7767 16.1256 10.7679 16.0107H1.75382Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.26131 13.9237C7.02971 13.9237 7.65262 13.3008 7.65262 12.5324C7.65262 11.764 7.02971 11.1411 6.26131 11.1411C5.49291 11.1411 4.87 11.764 4.87 12.5324C4.87 13.3008 5.49291 13.9237 6.26131 13.9237Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.13086 12.1846V16.7063C3.13086 19.1026 6.2613 19.8368 6.2613 19.8368C6.2613 19.8368 9.39173 19.1026 9.39173 16.7063V12.1846H3.13086Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.26239 18.3807C5.68164 18.1717 4.5217 17.6376 4.5217 16.7064V13.5759H8.00001V16.7064C8.00001 17.6407 6.8402 18.1735 6.26239 18.3807Z",
    fill: "#338AF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.9569 15.315V14.6193L6.26127 14.2715L5.56559 14.6193V15.315L5.21777 15.6628V17.0541H7.30477V15.6628L6.9569 15.315Z",
    fill: "#F3F3F3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1354_16465"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.0107422)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagSintMaarten);
export default __webpack_public_path__ + "static/media/flag_sint_maarten.4c517069a9d3b2c8e15f61a74348efa3.svg";
export { ForwardRef as ReactComponent };